import {
  ImageBackground,
  Image,
  StyleSheet,
  Text,
  View,
  Dimensions,
} from 'react-native';
import { translate } from 'react-i18next';
import React, { Component } from 'react';
import progressActor from '../assets/images/progress-actor-full.jpg';
import { defaultScale } from '../utils/scaling';
import FBLogo from '../assets/images/logo-black.png';
import Theme from '../theme';
import { Button, ButtonTypes } from '../components';
const { width } = Dimensions.get('window');

class EliteSetupScreen extends Component {
  render() {
    const { t, navigation } = this.props;
    return (
      <View style={styles.root}>
        <ImageBackground
          source={progressActor}
          style={styles.imageStyle}
          resizeMode='cover'
        ></ImageBackground>
        <View style={styles.footer}>
          <View style={styles.detailContainer}>
            <Image source={FBLogo} style={styles.logo} />
          </View>
          <Text style={styles.descriptionText}>
            {t('getStartedInAFewSteps')}
          </Text>
          <View style={styles.buttonContainer}>
            <Button
              title={t('startSetup')}
              containerStyle={styles.buttonStyle}
              onPress={() => navigation.navigate('Wifi')}
              buttonType={ButtonTypes.NORMAL}
              overrideFontStyles={styles.buttonTextStyle}
            />
          </View>
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  root: {
    width,
    height: '100%',
    backgroundColor: Theme.WHITE,
  },
  detailContainer: {
    alignItems: 'center',
  },
  logo: {
    width: defaultScale(315),
    height: defaultScale(122),
    resizeMode: 'contain',
  },
  imageStyle: {
    flex: 3,
    width,
  },
  footer: {
    flex: 1,
    justifyContent: 'space-between',
  },
  descriptionText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    paddingVertical: defaultScale(10),
  },
  buttonContainer: {
    padding: defaultScale(15),
  },
  buttonStyle: {
  },
  buttonTextStyle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.WHITE,
  },
});

export default translate(['elite'], { wait: true })(
  EliteSetupScreen,
);
